module.exports = __webpack_public_path__ + "static/media/32-1.55446579.mp3";